import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import CollapsibleCheckbox from './collapsible-checkbox';
import {useDailyCareLogFilters} from '../../../contexts/dailycare-log-filters/context';
import CheckboxSkeleton from './checkbox-skeleton';
import {translations} from '../../../i18n/translations';
import NestedCheckbox from '../../checkbox/nested-checkbox';
import {getLocalizedFieldValue} from '../../../utils/functions/get-localized-field-value';
import {useEntity} from '../../../contexts/entity/context';

export const DailyCareLogSocialResponsesFilters = () => {
  const [expanded, setExpanded] = useState(false);
  const {
    state: {userEntitySocialResponses},
  } = useEntity();
  const {t} = useTranslation();
  const {
    tasksFilters: {socialResponseIds},
    toggleSocialResponseFilter,
    toggleAllSocialResponseFilters,
  } = useDailyCareLogFilters();

  const socialResponsesChecked =
    userEntitySocialResponses?.some((socialResponse) =>
      socialResponseIds?.includes(socialResponse.id)
    ) ?? false;

  return (
    <>
      {userEntitySocialResponses ? (
        <CollapsibleCheckbox
          label={t(translations.daily_care_log.task_table.drawer.filters.social_responses)}
          checked={socialResponsesChecked}
          onChange={(checked) => toggleAllSocialResponseFilters(checked)}
          expanded={expanded}
          toggleExpanded={setExpanded}
        >
          {userEntitySocialResponses.map((socialResponse) => {
            const socialResponseChecked = socialResponseIds?.includes(socialResponse.id);

            return (
              <NestedCheckbox
                key={socialResponse.id}
                label={getLocalizedFieldValue(socialResponse, 'abbreviation')}
                checked={socialResponseChecked}
                onChange={(selected) => toggleSocialResponseFilter(socialResponse.id, selected)}
              />
            );
          })}
        </CollapsibleCheckbox>
      ) : (
        <CheckboxSkeleton />
      )}
    </>
  );
};
